/* eslint-disable brace-style */
import util from '../util'

let controller = 'SaldoBloqueadoDBSCore'

export default Object.assign({}, util.GetCrud(controller, ['get']), {
  ListarAgrupado(dto) {
    return util.Axios.GetAll(controller + '/ListarAgrupado', dto, true);
  },
  Listar(dto) {
    return util.Axios.GetAll(controller + '/Listar', dto, true);
  },
  Reprocessar(codigos) {
    return util.Axios.Post(controller + '/Reprocessar', codigos);
  },
  Cancelar(codigosSaldoBloqueado) {
    return util.Axios.Post(controller + '/Cancelar' ,codigosSaldoBloqueado);
  }
})
